import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHeart, faComment } from '@fortawesome/free-regular-svg-icons';
import { faTrashCan, faHeart as faHeartSolid, faComment as faCommentSolid } from '@fortawesome/free-solid-svg-icons';
import 'stylesheets/MainAppStyles/NoteActions.css'
import { useAuth } from 'hooks/auth';
import { IconButton } from '@chakra-ui/react';
import { useDeleteNote, useToggleLike } from 'hooks/notes';
import { Link } from 'react-router-dom';
import { PROTECTED } from 'lib/routes';
import { useComments } from 'hooks/comments';

const Actions = ({ note }) => {
    const { id, likes, uid } = note
    const { user, isLoading: userLoading } = useAuth()

    const isLiked = likes.includes(user?.id);

    const { toggleLike, isLoading: likeLoading } = useToggleLike(
        {
            id,
            isLiked,
            uid: user?.id
        }
    );

    const { deleteNote, isLoading: deleteLoading } = useDeleteNote(id)
    const { comments, isLoading: commentsLoading } = useComments(id)


    const handleToggleLike = (e) => {
        e.stopPropagation()
        toggleLike()
    }

    const handleDeleteClick = (e) => {
        e.stopPropagation()
        deleteNote()
    }

    return (
        <div className='actions-main-container'>
            <div className='button-main-container like-container'>
                <IconButton color="#" onClick={handleToggleLike} isLoading={likeLoading || userLoading} minW="25" h="25" className='like-button icon-button' icon={isLiked ? <FontAwesomeIcon icon={faHeartSolid} /> : <FontAwesomeIcon icon={faHeart} />} />
            </div>
            <p>{likes.length}</p>
            <div className='button-main-container comment-container'>
                <IconButton color="#" as={Link} to={`${PROTECTED}/comments/${id}`} isLoading={commentsLoading || userLoading} minW="25" h="25" className='comment-button icon-button' icon={comments?.length !== 0 ? <FontAwesomeIcon icon={faCommentSolid} /> : <FontAwesomeIcon icon={faComment} />} />
            </div>
            <p>{comments?.length}</p>
            {!userLoading && user.id === uid && (
                <div className='button-main-container trash-container'>
                    <IconButton color="#" onClick={handleDeleteClick} isLoading={deleteLoading || userLoading} minW="25" h="25" className='trash-button icon-button' icon={<FontAwesomeIcon icon={faTrashCan} />} />
                </div>
            )}
        </div>
    )
}

export default Actions